import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { Util } from '@grandvisionhq/forms';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { shouldCreateAccount } from '../../selectors.js';
import { markFieldsTouched, setMyAccountValidation, setServiceStoreValidation } from '../actions.js';

const useInvalidShippingStep = ()=>{
    var ref4, ref1, ref2, ref3;
    const checkoutSettings = useCheckoutSettings();
    const dispatch = useDispatch();
    const isCreateAccountRequired = Boolean(((ref4 = checkoutSettings.account) === null || ref4 === void 0 ? void 0 : ref4.implicitAccountCreation) || ((ref1 = checkoutSettings.account) === null || ref1 === void 0 ? void 0 : ref1.createAccountRequired));
    const shouldCreateAccountBoolean = useSelector(shouldCreateAccount);
    const isServiceStoreEnabled = (ref2 = checkoutSettings.features) === null || ref2 === void 0 ? void 0 : ref2.isServiceStoreEnabled;
    const handleInvalidStepShipping = React.useCallback(()=>{
        var ref;
        dispatch(markFieldsTouched());
        if (isCreateAccountRequired && !shouldCreateAccountBoolean) {
            dispatch(setMyAccountValidation());
        }
        if (isServiceStoreEnabled && !((ref = checkoutSettings.serviceStore) === null || ref === void 0 ? void 0 : ref.isOptional)) {
            dispatch(setServiceStoreValidation());
        }
        toast.failed('checkout.errors.form.general');
        Util.focusToTopErrorFieldOnScreen();
    }, [
        (ref3 = checkoutSettings.serviceStore) === null || ref3 === void 0 ? void 0 : ref3.isOptional,
        dispatch,
        isCreateAccountRequired,
        isServiceStoreEnabled,
        shouldCreateAccountBoolean, 
    ]);
    return {
        handleInvalidStepShipping
    };
};

export { useInvalidShippingStep };
//# sourceMappingURL=use-invalid-shipping-step.js.map
